import { Flex, FlexBehavior, FlexAlignItems, magma } from 'react-magma-dom';
import { OpenInNewIcon } from 'react-magma-icons';
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { StorybookIcon } from "../../../../src/images/icons/storybook-icon";
import * as React from 'react';
export default {
  Flex,
  FlexBehavior,
  FlexAlignItems,
  magma,
  OpenInNewIcon,
  LeadParagraph,
  StorybookIcon,
  React
};